var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('organism-policy-management',{attrs:{"fields":_vm.fields,"items":_vm.items},on:{"deletePolicy":_vm.deletePolicy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }